import { render } from "./EditDiscussionProfileModeModal.vue?vue&type=template&id=f64b8dd2&scoped=true"
import script from "./EditDiscussionProfileModeModal.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./EditDiscussionProfileModeModal.vue?vue&type=script&charset=utf-8&lang=js"

import "./EditDiscussionProfileModeModal.vue?vue&type=style&index=0&id=f64b8dd2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f64b8dd2"]])

export default __exports__